// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/UI/Modal/Modal.css
// module id = 610
// module chunks = 0